// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDtXC6EoyIiGegggJLpDIz_BH_9lxaLS-0",
  authDomain: "centenaire-9f0ab.firebaseapp.com",
  projectId: "centenaire-9f0ab",
  storageBucket: "centenaire-9f0ab.appspot.com",
  messagingSenderId: "846509607924",
  appId: "1:846509607924:web:e9f148581e31dadb8b47a1",
  measurementId: "G-MJR3ZHZ8NP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);